export class User {
  userName: string;
  password: string;
}
